import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const AccordionOuterWrapper = styled(Box)(({ theme, accordionstyle }) => (`
  margin:20px 0;
  padding:10px 20px 20px 20px;
  position: relative;
  // transition: ${theme.transition};
  transition: all 0.5s ease;
  background: ${(accordionstyle === 'default' || accordionstyle === 'filter')
    ? theme.components.AccordionWithArrow.styleOverrides.background1
    : theme.components.AccordionWithArrow.styleOverrides.background2};
  border: 1px solid ${(accordionstyle === 'default' || accordionstyle === 'filter')
    ? theme.components.AccordionWithArrow.styleOverrides.borderColor1
    : theme.components.AccordionWithArrow.styleOverrides.borderColor2};

  &.expanded_false { padding: 5px 20px; margin:0 0 20px 0; }
  &.expanded_false .heading { margin:0; }
  &.expanded_false .heading button { transform: rotate(-90deg);}
  &.expanded_true { margin:30px 0; }
  
  & > * {
    transition: all 0.5s ease;
    // font-size: 14px;
  }

  & input {
    // font-size: 14px;
  }

  & label {
    // font-size: 14px;
    // font-style: normal;
    // font-weight: 300;
    // line-height: normal;
  }

  & .MuiGrid-item.MuiGrid-grid-xs-3 {
    padding-top:8px
  }
`))

export const HeadingWrapper = styled(Box)(({ theme, accordionstyle }) => (`
  margin-top: ${(accordionstyle === 'default' || accordionstyle === 'filter') ? 0 : -30}px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  position: relative;
  z-index: 2;

  & button {
    padding: 0;
    border-radius: 50%;
    min-width: 30px;
    display: ${accordionstyle === 'default' ? 'none' : 'inline-flex'};
  }

  & button #arrow {
    stroke: ${theme.components.AccordionWithArrow.styleOverrides.buttonColor};
  }
  
  & button #circle {
    fill: ${theme.components.AccordionWithArrow.styleOverrides.buttonBackground};
    stroke: ${theme.components.AccordionWithArrow.styleOverrides.buttonBackground};
  }
`))

export const Heading = styled('span')(({ theme, accordionstyle }) => (`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: inline-block;
  padding: 0 8px;
  margin-left: -10px;
  background: ${(accordionstyle === 'default' || accordionstyle === 'filter')
    ? theme.components.AccordionWithArrow.styleOverrides.titleBackground1
    : theme.components.AccordionWithArrow.styleOverrides.titleBackground2};
  transition: ${theme.transition};
`))

export const ShowOverlay = styled('div')(({ theme }) => (`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -10;
  width: 1px;
  height: 1px;
  background: ${theme.components.AccordionWithArrow.styleOverrides.overlay};
`))
